import { z } from 'zod'
import { FeedEventSource } from '../segment.types'

export const swordDeskTicketCreatedSchema = z.object({
  masterTaskId: z.string(),
  memberStatus: z.string(),
  programUuid: z.string().uuid(),
  source: z.enum([FeedEventSource.CHART, FeedEventSource.SIDEBAR]),
})
